import React, { useEffect, useMemo } from 'react';
import _get from 'lodash/get';
import { FilterGroupingEnum, useDepartmentIdsQuery } from 'graphql-common';
import { Option } from '@lib/interfaces/form';

export default function useDepartmentLinksPrefill({
  groupKey,
  initialDepartmentLinksRef,
  skip = false,
}: {
  groupKey?: string;
  initialDepartmentLinksRef?: React.MutableRefObject<Option[]>;
  skip?: boolean;
}) {
  const { data, loading, error } = useDepartmentIdsQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      onlyIds: true,
      filters: [
        {
          departmentTaskGroupsGroupKey: {
            grouping: FilterGroupingEnum.And,
            predicate: { eq: groupKey || '' },
          },
        },
      ],
    },
    skip: !groupKey || skip,
  });

  const initialDepartmentLinks: Option[] = useMemo(() => {
    const ids = _get(data, 'data.collection', []) as Array<{ id: string }>;
    return ids.map(({ id }) => ({ value: id }));
  }, [data]);

  useEffect(() => {
    if (!groupKey || !data) return;
    if (initialDepartmentLinksRef) {
      // eslint-disable-next-line no-param-reassign
      initialDepartmentLinksRef.current = initialDepartmentLinks;
    }
  }, [data, groupKey, initialDepartmentLinks, initialDepartmentLinksRef]);

  return {
    initialDepartmentLinks,
    loading: Boolean(groupKey) && !skip && !error && (loading || !data),
  };
}
